import type {
  ListingsAPIRequestBody,
  ListingsAPIResponseBody,
  ListingsAPISponsoredContext,
} from '@noths/polaris-client-listings-api';
import { fetchListingsData } from '@noths/polaris-client-listings-api';
import { isBrowser } from '@noths/polaris-client-utils';

import { isProd } from 'src/environment';
import { logger } from 'src/utils/serverLogger';
import { getListingsAPIUrl } from './getListingsAPIUrl';

interface GetListingsDataArgs {
  body: ListingsAPIRequestBody;
  bot?: boolean;
  servingConfig?: string;
  sponsored?: ListingsAPISponsoredContext;
  userId?: string;
  visitorId?: string;
}

export const getListingsData = async ({
  body,
  bot = false,
  servingConfig,
  sponsored,
  userId,
  visitorId,
}: GetListingsDataArgs): Promise<ListingsAPIResponseBody | null> => {
  try {
    const clientSide = isBrowser();
    const data = await fetchListingsData({
      body,
      bot,
      clientSide,
      env: isProd() ? 'prod' : 'qa',
      servingConfig,
      sponsored,
      timeout: clientSide ? 15000 : 5500,
      url: getListingsAPIUrl('listings', clientSide),
      userId,
      visitorId,
    });

    if ('products' in data) {
      return data as ListingsAPIResponseBody;
    }

    logger.error('bad response from listings-api', {
      error: data.message,
    });
  } catch (error) {
    logger.error('error fetching data from listings-api', {
      error: (error as Error).message,
    });
  }

  return null;
};
